import { useEffect, useLayoutEffect, useRef, useState } from "react"
import { useNavigate, useOutletContext, useParams } from "react-router-dom"
import { useSWRConfig } from "swr"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { Transition } from "components"
import { useAuth } from "contexts/auth-context"
import Form from "./form"
import { showSuratJalanUmum, updateSuratJalanUmum } from "./api"

export default function Edit() {
  const { id } = useParams()
  const { user } = useAuth()
  const { cache } = useSWRConfig()
  const { setTitle } = useOutletContext()
  const navigate = useNavigate()

  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [errors, setErrors] = useState({})
  const [submitting, setSubmitting] = useState(false)
  const submittingRef = useRef(false)

  useLayoutEffect(() => {
    setTitle("Edit Surat Jalan Umum")
  }, [])

  useEffect(() => {
    let cancelled = false
    nProgress.start()
    showSuratJalanUmum(id)
      .then((res) => {
        if (!cancelled) setData(res?.data ?? null)
      })
      .catch((err) => toast.error(err?.message || "Gagal memuat dokumen"))
      .finally(() => {
        if (!cancelled) setLoading(false)
        nProgress.done()
      })
    return () => {
      cancelled = true
    }
  }, [id])

  const handleSubmit = async (payload) => {
    if (submittingRef.current) return
    submittingRef.current = true
    setSubmitting(true)
    setErrors({})
    nProgress.start()
    toast.loading("Menyimpan", { id: "sju-submit" })

    try {
      const result = await updateSuratJalanUmum(id, payload, user?.name)
      cache.clear()
      toast.success(result?.message || "Perubahan tersimpan", { id: "sju-submit" })
      navigate("/surat-jalan-umum")
    } catch (err) {
      if (err?.validation && typeof err.validation === "object") setErrors(err.validation)
      toast.error(err?.message || "Gagal menyimpan", { id: "sju-submit" })
    } finally {
      submittingRef.current = false
      setSubmitting(false)
      nProgress.done()
    }
  }

  if (loading) {
    return <div className="p-6 text-sm text-neutral-500">Memuat...</div>
  }

  if (!data) {
    return <div className="p-6 text-sm text-red-600">Dokumen tidak ditemukan.</div>
  }

  return (
    <Transition type="fade">
      <Form data={data} errors={errors} onSubmit={handleSubmit} submitting={submitting} />
    </Transition>
  )
}
